// FET MARKERS
export const FETCH_MARKERS_LOADING = 'FETCH_MARKERS_LOADING'
export const FETCH_MARKERS_SUCCESS = 'FETCH_MARKERS_SUCCESS'
export const FETCH_MARKERS_ERROR = 'FETCH_MARKERS_ERROR'